<app-dialog-container
  title="{{ 'copyStatus' | translate }}"
  [showCancelButton]="true"
  [cancelButtonText]="'close' | translate"
  [showConfirmButton]="false"
  (cancelButtonHandler)="close()"
>
  <div class="copy-status-content" *ngIf="copyStatus$ | async as copyStatus">
    <div class="status-item">
      <span class="status-label">{{ 'pendingCopies' | translate }}:</span>
      <span class="status-value pending">{{ copyStatus.pendingCount }}</span>
    </div>
    <div class="status-item">
      <span class="status-label">{{ 'failedCopies' | translate }}:</span>
      <span class="status-value failed">{{ copyStatus.failedCount }}</span>
    </div>
  </div>
</app-dialog-container>
